"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid = __importStar(require("uuid"));
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
const formWithTreeToFormQuestions = (formWithTree) => {
    var _a, _b;
    return (_b = (_a = formWithTree.questionTree.subQuestions) === null || _a === void 0 ? void 0 : _a.map(q => toFormQuestion(q, formWithTree)).filter(q => !!q)) !== null && _b !== void 0 ? _b : [];
};
exports.default = formWithTreeToFormQuestions;
const toFormQuestionOption = (q, o, formWithTree) => {
    var _a, _b;
    return Object.assign(Object.assign({}, o), { subQuestions: Object.assign({ 
            // eslint-disable-next-line max-len
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment
            sqId: uuid.v4(), questions: (_a = o.subQuestions) === null || _a === void 0 ? void 0 : _a.map(s => {
                var _a;
                const node = (_a = q.subQuestions) === null || _a === void 0 ? void 0 : _a.find(n => n.questionId === s);
                return toFormQuestion(node, formWithTree);
            }) }, (((_b = o.subQuestions) === null || _b === void 0 ? void 0 : _b.length) > 0 ? { enabled: true } : undefined)) });
};
const toFormQuestionConfig = (q, formWithTree) => {
    var _a, _b, _c;
    const rule = formWithTree.rules[q.questionId];
    switch (q === null || q === void 0 ? void 0 : q.type) {
        case FormQuestionType_1.default.REPETITION: {
            const c = rule;
            return Object.assign(Object.assign({}, c), { unLimitedTimes: {
                    enabled: c.unLimitedTimes.enabled,
                    value: c.unLimitedTimes.enabled ? q.totalRepetitions : c.unLimitedTimes.value,
                }, questions: (_a = c.questions) === null || _a === void 0 ? void 0 : _a.map(s => {
                    var _a;
                    const node = (_a = q.subQuestions) === null || _a === void 0 ? void 0 : _a.find(n => n.questionId === s);
                    return toFormQuestion(node, formWithTree);
                }) });
        }
        case FormQuestionType_1.default.QUESTIONSET:
        case FormQuestionType_1.default.SECTION: {
            const c = rule;
            return Object.assign(Object.assign({}, c), { questions: (_b = c.questions) === null || _b === void 0 ? void 0 : _b.map(s => {
                    var _a;
                    const node = (_a = q.subQuestions) === null || _a === void 0 ? void 0 : _a.find(n => n.questionId === s);
                    return toFormQuestion(node, formWithTree);
                }) });
        }
        case FormQuestionType_1.default.CHECK: {
            const c = rule;
            return Object.assign(Object.assign({}, c), { yes: toFormQuestionOption(q, c.yes, formWithTree), no: toFormQuestionOption(q, c.no, formWithTree) });
        }
        case FormQuestionType_1.default.NUMBER: {
            const c = rule;
            return Object.assign(Object.assign({}, c), { lessThan: toFormQuestionOption(q, c.lessThan, formWithTree), moreThan: toFormQuestionOption(q, c.moreThan, formWithTree) });
        }
        case FormQuestionType_1.default.RATING: {
            const c = rule;
            return Object.assign(Object.assign({}, c), { rating0: toFormQuestionOption(q, c.rating0, formWithTree), rating1: toFormQuestionOption(q, c.rating1, formWithTree), rating2: toFormQuestionOption(q, c.rating2, formWithTree), rating3: toFormQuestionOption(q, c.rating3, formWithTree), rating4: toFormQuestionOption(q, c.rating4, formWithTree) });
        }
        // -----------------
        // PAUSE DEPRECATION
        //case FormQuestionType.PAUSE:
        // -----------------
        case FormQuestionType_1.default.LIST: {
            const c = rule;
            return Object.assign(Object.assign({}, c), { options: (_c = c.options) === null || _c === void 0 ? void 0 : _c.map(o => toFormQuestionOption(q, o, formWithTree)) });
        }
        case FormQuestionType_1.default.DATETIME:
        case FormQuestionType_1.default.INFO:
        case FormQuestionType_1.default.ISSUE:
        case FormQuestionType_1.default.PHOTO:
        case FormQuestionType_1.default.SIGNATURE:
        case FormQuestionType_1.default.SPT:
        case FormQuestionType_1.default.ASSET:
        case FormQuestionType_1.default.TEXT: {
            return rule;
        }
    }
};
/* eslint-disable @typescript-eslint/no-unused-vars */
const toFormQuestion = (q, formWithTree) => {
    if (!!q &&
        (!((q === null || q === void 0 ? void 0 : q.repetitionAncestorId) || (q === null || q === void 0 ? void 0 : q.type) === FormQuestionType_1.default.REPETITION) ||
            (q === null || q === void 0 ? void 0 : q.repetitionIndex) === 0)) {
        const { questions, answers } = formWithTree;
        const { subQuestions, nodeId, questionId, parentNodeId, enabled, repetitionAncestorId, repetitionIndex, totalRepetitions } = q, rest = __rest(q, ["subQuestions", "nodeId", "questionId", "parentNodeId", "enabled", "repetitionAncestorId", "repetitionIndex", "totalRepetitions"]);
        let answer = [];
        if (answers) {
            answer = [answers[nodeId]];
            const repAncestor = questions[repetitionAncestorId];
            if (repetitionIndex === 0 &&
                q.type !== FormQuestionType_1.default.REPETITION &&
                q.type !== FormQuestionType_1.default.QUESTIONSET &&
                q.type !== FormQuestionType_1.default.SECTION &&
                repAncestor) {
                const allQuestions = Object.values(questions);
                answer = allQuestions
                    .filter(qq => qq.questionId === q.questionId &&
                    qq.repetitionAncestorId &&
                    questions[qq.repetitionAncestorId].questionId === repAncestor.questionId)
                    .map(qq => answers[qq.nodeId]);
            }
        }
        return Object.assign(Object.assign({ qId: questionId }, rest), { config: {
                [q.type]: toFormQuestionConfig(q, formWithTree),
            }, answer });
    }
};
